import type { CardTransaction, CardTransactionStatus, Merchant } from '../cards.types';

type TransactionSeed = [
  daysAgo: number,
  merchant: Merchant,
  status: CardTransactionStatus,
  amount: number,
  direction?: 'in',
];

const seedTransactions: TransactionSeed[] = [
  [12, { name: 'Zara Quinn', kind: 'logo' }, 'completed', 1944],
  [11, { name: 'Cashback', kind: 'cashback' }, 'completed', 2, 'in'],
  [5, { name: 'Clara Voss', kind: 'contact' }, 'processing', 715],
  [9, { name: 'Hilton Berlin', kind: 'hotel' }, 'failed', 1944],
  [7, { name: 'London Airport', kind: 'travel' }, 'completed', 534.15],
  [1, { name: 'Netflix', kind: 'transfer' }, 'completed', 9.99],
  [8, { name: 'Refund', kind: 'refund' }, 'completed', 1944, 'in'],
  [3, { name: 'Acne Inc', kind: 'invoice' }, 'missing_otp', 534.15],
  [12, { name: 'Amazon', kind: 'logo' }, 'completed', 25.06],
  [4, { name: 'ATM · Sparkasse', kind: 'atm' }, 'completed', 849],
  [9, { name: 'Acne Inc', kind: 'hotel' }, 'failed', 320],
  [12, { name: 'Amazon', kind: 'logo' }, 'completed', 25.06],
  [6, { name: 'Lidl Berlin', kind: 'transfer' }, 'completed', 47.5],
  [6, { name: 'Lidl Berlin', kind: 'transfer' }, 'completed', 1320],
  [1, { name: 'Shopify', kind: 'shop' }, 'completed', 944.26],
  [6, { name: 'ATM · Sparkasse', kind: 'atm' }, 'completed', 945],
  [5, { name: 'Clara Voss', kind: 'contact' }, 'processing', 715],
  [2, { name: 'Spotify', kind: 'logo' }, 'completed', 9.99],
  [10, { name: 'Adobe Creative Cloud', kind: 'logo' }, 'completed', 20],
  [14, { name: 'Uber', kind: 'travel' }, 'completed', 18.4],
];

const occurredAt = (daysAgo: number) => {
  const date = new Date();

  date.setUTCDate(date.getUTCDate() - daysAgo);
  date.setUTCHours(3, 12, 0, 0);

  return date.toISOString();
};

const buildTransactions = (cardId: string, spread: number): CardTransaction[] =>
  seedTransactions.map(([daysAgo, merchant, status, amount, direction], index) => ({
    id: `TX-${cardId.slice(-4)}-${String(index + 1).padStart(4, '0')}`,
    cardId,
    occurredAt: occurredAt(daysAgo * spread),
    merchant,
    status,
    amount,
    direction: direction ?? 'out',
  }));

export const transactionsFixture: CardTransaction[] = [
  ...buildTransactions('card-eur-main-9374', 2),
  ...buildTransactions('card-eur-taxes-2364', 3).slice(0, 8),
  ...buildTransactions('card-eur-business-8829', 1).slice(4, 16),
  ...buildTransactions('card-usd-main-0023', 4).slice(2, 12),
  ...buildTransactions('card-gbp-main-6671', 6).slice(0, 5),
];
